// extracted by mini-css-extract-plugin
export default {"modalWrap":"ModalOrderManage_modalWrap__EGQR5","modalContainer":"ModalOrderManage_modalContainer__N61Qc","modalContent":"ModalOrderManage_modalContent__u7Q6N"};